import api, { LOCALE_HOST } from '@whitelabel/xcover-shared/helpers/api';

export const loadMessages = (locale: string, requestInit?: RequestInit): any =>
  api.get(`${LOCALE_HOST}/?language=${locale}`, false, requestInit || {});

export const loadFEMessages = (locale: string, slug: string): any =>
  api.get(`${process.env.REACT_APP_MESSAGES_HOST}/${slug}/?language=${locale}`, false);
